import clsx from 'clsx';

interface PageHeaderProps {
  title: string;
  actions?: React.ReactNode;
  className?: string;
  containerClassName?: string;
}

export default function PageHeader({ title, className, actions, containerClassName }: PageHeaderProps) {
  return (
    <div className={clsx('flex w-full items-start justify-between', containerClassName)}>
      <h1 className={clsx('text-blue-900', className)}>{title}</h1>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
